// Module
var code = `{{#}}
<a
  class="nav"
  data-channel="ROUTE"
  data-event-prevent-default="true"
  data-page-id="{{pageId}}"
  data-text="{{title}}"
  data-end-route="true"
  href="{{href}}"
  >{{title}}</a
>
{{/}}

<!-- Light/Dark Toggle -->
<button
  id="theme-toggle"
  data-event-type="setting"
  data-settings-type="theme"
  data-settings-value="light"
  class="nav theme-toggle"
  aria-label="Toggle Theme"
>

  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
    <!-- Generator: Adobe Illustrator 30.1.0, SVG Export Plug-In . SVG Version: 2.1.1 Build 136)  -->
    <defs>
      <style>
          .st0-moon {
              fill: #6b6b6b;
          }

          .st1-moon {
              fill: #fff;
              isolation: isolate;
          }
      </style>
    </defs>
    <path class="st1-moon" d="M64,256c2.6,104.5,85.4,192,192,192,49.7-1.3,96.8-18.8,132.9-53.6,5.5-5.3,7-13.4,3.9-20.3s-10.2-11.2-17.8-10.6c-76.4,3.4-144.9-51.7-148.9-130.4-1.4-54.6,26.8-106,76.3-130.7,6.8-3.4,10.8-10.7,9.8-18.3-.8-6.6-5.2-12.2-11.2-14.6-14.6-4.6-30-5.2-45.2-5.6-106,0-192,86-192,192h.2Z"/>
    <path class="st0-moon" d="M256,512C114.6,512,0,397.4,0,256S114.6,0,256,0s256,114.6,256,256-114.6,256-256,256ZM256,64c-106,0-192,86-192,192,2.6,104.5,85.4,192,192,192,49.7-1.3,96.8-18.8,132.9-53.6,5.5-5.3,7-13.4,3.9-20.3s-10.2-11.2-17.8-10.6c-76.4,3.4-144.9-51.7-148.9-130.4-1.4-54.6,26.8-106,76.3-130.7,6.8-3.4,10.8-10.7,9.8-18.3-.8-6.6-5.2-12.2-11.2-14.6-14.6-4.6-30-5.2-45.2-5.6h.2Z"/>
  </svg>

</button>
`;
// Exports
module.exports = code;